import axios from 'axios';
import apiClient from '@/services/apiClient';

const TOKEN = 'my_pay_token';
const SITE = 'my_pay_site';
const LANG = 'my_pay_lang';
const MONTH = 'my_pay_month';

export const myPayStore = {
  token: () => sessionStorage.getItem(TOKEN),
  setToken: (t) => (t ? sessionStorage.setItem(TOKEN, t) : sessionStorage.removeItem(TOKEN)),
  month: () => sessionStorage.getItem(MONTH),
  setMonth: (m) => (m ? sessionStorage.setItem(MONTH, m) : sessionStorage.removeItem(MONTH)),
  site: () => localStorage.getItem(SITE) || localStorage.getItem('active_site_id') || 'salem',
  setSite: (s) => localStorage.setItem(SITE, s),
  lang: () => localStorage.getItem(LANG) || 'en',
  setLang: (l) => localStorage.setItem(LANG, l),
};

const http = () => axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/my-pay`,
  headers: { 'X-Site-Id': myPayStore.site(), ...(myPayStore.token() ? { 'X-Staff-Pass': myPayStore.token() } : {}) },
});

/** Public staff self-view (Staff ID + date of birth) — its own axios so a 401 never touches the WMS login. */
export const myPayApi = {
  sites: () => axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/sites-registry/public`).then((r) => (r.data.sites || []).filter((s) => !s.site_id.startsWith('__'))),
  login: (staffId, dob, extra = {}) => http().post('/login', { staff_id: staffId, dob, ...extra }).then((r) => r.data),
  month: (month) => http().get('/month', { params: { month } }).then((r) => r.data),
  logout: () => http().post('/logout').catch(() => {}),
  lookup: (staffId, month) => apiClient.get('/my-pay/lookup', { params: { staff_id: staffId, month } }).then((r) => r.data),
  pinReset: (staffId) => apiClient.post('/my-pay/pin-reset', { staff_id: staffId }).then((r) => r.data),
};

export const currentMonth = () => new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' }).slice(0, 7);

export const myPayErr = (e, fb) => e?.response?.data?.detail || (e?.response ? fb : 'No connection — check the network and try again');
